interface CompanyInfoInputs {
  displayName: Uppercase<string>;
  name: string;
  autocompleteTag: string;
  type?: 'number';
  dataCy?: string;
}

export const companyInfoInputs: CompanyInfoInputs[] = [
  {
    displayName: 'ORGANIZATION.COMPANY_NAME',
    name: 'companyName',
    autocompleteTag: 'organization',
    dataCy: 'company-name',
  },
  {
    displayName: 'ORGANIZATION.STREET',
    name: 'street',
    autocompleteTag: 'address-level3',
    dataCy: 'street',
  },
  {
    displayName: 'ORGANIZATION.HOUSE_NUMBER',
    name: 'houseNumber',
    autocompleteTag: 'address-level4',
    dataCy: 'house-number',
  },
  {
    displayName: 'ORGANIZATION.ZIP',
    name: 'zip',
    autocompleteTag: 'postal-code',
    dataCy: 'zip',
  },
  {
    displayName: 'ORGANIZATION.CITY',
    name: 'city',
    autocompleteTag: 'address-level2',
    dataCy: 'city',
  },
  {
    displayName: 'ORGANIZATION.COUNTRY',
    name: 'country',
    autocompleteTag: 'country-name',
    dataCy: 'country',
  },
  {
    displayName: 'ORGANIZATION.VAT_NUMBER',
    name: 'vatNumber',
    autocompleteTag: 'off',
    dataCy: 'vat-number',
  },
  {
    displayName: 'ORGANIZATION.EMAIL_FOR_INVOICE',
    name: 'emailForInvoice',
    autocompleteTag: 'email',
    dataCy: 'email-for-invoice',
  },
];
